export default __webpack_public_path__ + "static/media/by.be6fc507.svg";